import PermissionsManager from "./PermissionsManager";
export default class Feature {
    static isEnabled(feature) {
        if (!feature)
            return true;
        if (feature.length < 1)
            return true;
        return PermissionsManager.hasFeature(feature);
    }
}
//# sourceMappingURL=Feature.js.map